import React, { useEffect, useState } from "react";
import styles from "./orderIdDetails.module.scss";
import {
  Paper,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Modal,
  Box,
  Switch,
} from "@mui/material";
import EditOutlinedIcon from "@mui/icons-material/EditOutlined";
import { connect, useDispatch } from "react-redux";
import {
  getAllAddress,
  getAllOrders,
  getAllStates,
  updateOrders,
} from "../../../store/actions";
import { useNavigate } from "react-router-dom";
import { getObjectFromArrayOfObjects } from "../../../utils/common/CommonFunctions";

const OrderIdDetails = ({
  order = {},
  customer = {},
  loginUser = {},
  addresses,
  states,
  product,
}) => {
  const [open, setOpen] = useState(false);
  const [status, setStatus] = useState(null);
  const dispatch = useDispatch();
  const [showModal, setShowModal] = useState(false);
  const [showPackageModal, setShowPackageModal] = useState(false);
  const [dispatcherSwitchDisabled, setDispatcherSwitchDisabled] =
    useState(false);
  const [deliverySwitchDisabled, setDeliverySwitchDisabled] = useState(false);
  const [packagerSwitchDisabled, setPackagerSwitchDisabled] = useState(false);
  const navigate = useNavigate();

  const handleToggle = (event) => {
    if (event) {
      event.preventDefault();
      event.stopPropagation();
    }
    setShowModal(true);
  };
  const handlePackageToggle = (event) => {
    if (event) {
      event.preventDefault();
      event.stopPropagation();
    }
    setShowPackageModal(true);
  };
  const confirmPackageUpdate = () => {
    setPackagerSwitchDisabled(true);
    dispatch(updateOrders({ payload: { ...order, status: 1 } }));
    setShowPackageModal(false);
    window.history?.go(-1);
  };

  const confirmUpdate = () => {
    setDispatcherSwitchDisabled(true);
    dispatch(updateOrders({ payload: { ...order, status: 2 } }));
    setShowModal(false);
    window.history.go(-1);
  };
  const confirmDelivered = () => {
    setDeliverySwitchDisabled(true);
    dispatch(updateOrders({ payload: { ...order, status: 3 } }));
    setShowModal(false);
    window.history.go(-1);
  };

  const cancelUpdate = () => {
    setShowModal(false);
  };

  const cancelPackageupdate = () => {
    setShowPackageModal(false);
  };

  useEffect(() => {
    dispatch(getAllAddress());
    dispatch(getAllStates());
    setStatus(order?.status?.toString());
  }, []);

  useEffect(() => {
    if (order?.status === 1) {
      setDispatcherSwitchDisabled(false);
      setPackagerSwitchDisabled(false);
    }
    if (order?.status === 2) {
      setDeliverySwitchDisabled(false);
    }
  }, [order?.status]);

  const handleOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleNavigate = () => {
    dispatch(
      getAllOrders({
        callback: {
          success: (data) => navigate("/order"),
        },
      })
    );
  };

  const handlesuccessClose = () => {
    setOpen(false);
    dispatch(
      updateOrders({
        payload: { ...order, status: status },
        callback: {
          success: (data) => handleNavigate(),
        },
      })
    );
  };

  const handleStatusChange = (event) => {
    setStatus(event.target.value);
  };

  const handleStatus = (status) => {
    switch (status) {
      case -1:
        return "Cancelled";
      case 0:
        return "Placed";

      case 1:
        return "Packed";
      case 2:
        return "Shipped";
      case 3:
        return "Delivered";
    }
  };

  const getAddress = (id) => {
    const address = getObjectFromArrayOfObjects(addresses, "id", id);
    const state = getObjectFromArrayOfObjects(states, "id", address?.state);
    console.log("address", address);
    console.log("state", state);

    return (
      <div style={{ display: "flex", flexDirection: "column" }}>
        <div>
          {address?.addressLine1},<br></br>
          {address?.addressLine2},
        </div>
        <div>
          {address?.city},{state?.name},
        </div>
        <div>
          {address?.country}-{address?.postalCode}
        </div>
      </div>
    );
  };

  return (
    <>
      <Paper classes={{ root: styles.container }}>
        <div className={styles.wrapper}>
          <div className={styles.list}>
            <div className={styles.label}>Order ID</div>
            <div className={styles.value}>: {order?.orderCode}</div>
          </div>{" "}
          <div className={styles.list}>
            <div className={styles.label}>Customer Name</div>
            <div className={styles.value}>: {customer?.fullName}</div>
          </div>
          <div className={styles.list}>
            <div className={styles.label}>Customer Mobile Number</div>
            <div className={styles.value}>: {customer?.phoneNumber}</div>
          </div>
          <div className={styles.list}>
            <div className={styles.label}>Customer Email ID</div>
            <div className={styles.value}>: {customer?.email}</div>
          </div>
          <div className={styles.list}>
            <div className={styles.label}>Order Quantity</div>
            <div className={styles.value}>: {order?.quantity}</div>
          </div>
        </div>
        <div className={styles.wrapper}>
          {" "}
          <div className={styles.list} style={{ alignItems: "start" }}>
            <div className={styles.label}>Delivery address</div>
            <div className={styles.value} style={{ alignItems: "start" }}>
              : {getAddress(order?.addressId)}
            </div>
          </div>
          <div className={styles.list}>
            <div className={styles.label}>Product Name</div>
            <div className={styles.value}>: {product?.name}</div>
          </div>
          {/* <div className={styles.list}>
            <div className={styles.label}>Status</div>

            {loginUser?.role === "dispatcher" && order?.status === 1 ? (
              <div className={styles.value}>
                :{" "}
                <Switch
                  checked={false}
                  onChange={handleToggle}
                  disabled={dispatcherSwitchDisabled}
                  color="primary"
                />
                <span>Shipped</span>
              </div>
            ) : loginUser?.role === "dispatcher" && order?.status === 2 ? (
              <div className={styles.value}>
                :{" "}
                <Switch
                  checked={false}
                  onChange={handleToggle}
                  disabled={deliverySwitchDisabled}
                  color="primary"
                />
                <span>Delivered</span>
              </div>
            ) : loginUser?.role === "packager" ? (
              <div className={styles.value}>
                :{" "}
                <Switch
                  checked={order?.status >= 1}
                  onChange={handlePackageToggle}
                  disabled={packagerSwitchDisabled || order?.status >= 1}
                  color="primary"
                />
                <span>Packed</span>
              </div>
            ) : loginUser?.role === "admin" ? (
              <div className={styles.value}>
                : {handleStatus(order?.status)}
                <EditOutlinedIcon
                  className={styles.editIcon}
                  onClick={handleOpen}
                />
              </div>
            ) : (
              <div className={styles.value}>Completed</div>
            )}

          
            <Modal open={showModal} onClose={cancelUpdate}>
              <Box
                sx={{
                  position: "absolute",
                  top: "50%",
                  left: "50%",
                  transform: "translate(-50%, -50%)",
                  bgcolor: "background.paper",
                  borderRadius: "10px",
                  p: 3,
                  width: 350,
                  textAlign: "center",
                }}
              >
                <p>
                  Are you sure you want to update this order from
                  {order?.status === 1 ? <b> Pack </b> : <b> Shipped </b>}
                  to
                  {order?.status === 1 ? <b> Ship</b> : <b> Delivered</b>}?
                </p>
                <Box
                  sx={{
                    mt: 2,
                    display: "flex",
                    justifyContent: "space-around",
                  }}
                >
                  {" "}
                  <Button
                    variant="contained"
                    color="error"
                    onClick={cancelUpdate}
                  >
                    No
                  </Button>
                  <Button
                    variant="contained"
                    color="success"
                    onClick={
                      order?.status === 1
                        ? () => confirmUpdate()
                        : () => confirmDelivered()
                    }
                  >
                    Yes
                  </Button>
                </Box>
              </Box>
            </Modal>

            <Modal open={showPackageModal} onClose={cancelPackageupdate}>
              <Box
                sx={{
                  position: "absolute",
                  top: "50%",
                  left: "50%",
                  transform: "translate(-50%, -50%)",
                  bgcolor: "background.paper",
                  borderRadius: "10px",
                  p: 3,
                  width: 350,
                  textAlign: "center",
                }}
              >
                <p>
                  Are you sure you want to update this order from <b>Placed</b>{" "}
                  to
                  <b> Pack</b> ?
                </p>
                <Box
                  sx={{
                    mt: 2,
                    display: "flex",
                    justifyContent: "space-around",
                  }}
                >
                  <Button
                    variant="contained"
                    color="error"
                    onClick={cancelPackageupdate}
                  >
                    No
                  </Button>{" "}
                  <Button
                    variant="contained"
                    color="success"
                    onClick={confirmPackageUpdate}
                  >
                    Yes
                  </Button>
                </Box>
              </Box>
            </Modal>
          </div> */}
        </div>
      </Paper>

      <Dialog
        open={open}
        onClose={handleClose}
        PaperProps={{
          className: styles.dialogContainer,
        }}
      >
        <DialogTitle>Change Status</DialogTitle>
        <DialogContent className={styles.wrapper}>
          <FormControl fullWidth margin="normal">
            <InputLabel id="status-label" className={styles.input}>
              Status
            </InputLabel>
            <Select
              labelId="status-label"
              value={status}
              label="Status"
              onChange={handleStatusChange}
            >
              <MenuItem value="0">Placed</MenuItem>
              <MenuItem value="1">Packed</MenuItem>
              <MenuItem value="2">Shipped</MenuItem>
              <MenuItem value="3">Completed</MenuItem>
              <MenuItem value="-1">Cancelled</MenuItem>
            </Select>
          </FormControl>
        </DialogContent>
        <DialogActions className={styles.buttons}>
          <Button onClick={handleClose} className={styles.cancelButton}>
            Cancel
          </Button>
          <Button
            onClick={() => {
              handlesuccessClose();
            }}
            className={
              status !== order?.status?.toString()
                ? styles.submitButton
                : styles.submitButtonDisable
            }
            disabled={status === order?.status?.toString()}
          >
            Submit
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

const mapStateToProps = (state, props) => {
  return {
    order: state?.orders?.order,
    customer: state?.customer?.customer,
    loginUser: state?.login?.user,
    addresses: state?.address?.addresses,
    states: state?.state?.states,
    product: state?.product?.product,
  };
};

export default connect(mapStateToProps, null)(OrderIdDetails);
